import styled, { css } from 'styled-components';
import { colors } from '../../../theme/colors';
import {
  SelectorContainer as Container,
  SelectorLabelText as LabelText,
  HiddenInput,
} from '../../sharedSelectorStyles';

export { Container, LabelText };

export const HiddenCheckbox = styled(HiddenInput).attrs({ type: 'checkbox' })``;

const getPrimaryColor = (props) => {
  if (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) {
    return props.theme.colors.brand.primary;
  }
  return colors.primary;
};

export const StyledCheckboxWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background: ${(props) => (props.checked ? colors.primary : 'transparent')};
  border: 2px solid ${(props) => (props.checked ? colors.primary : colors.brandLightGray)};
  border-radius: 6px;
  transition: all 0.2s;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px rgba(0, 169, 255, 0.25);
  }

  ${HiddenCheckbox}:hover + & {
    ${(props) =>
      !props.checked &&
      !props.disabled &&
      css`
        border-color: ${getPrimaryColor(props)};
      `}
  }
`;

export const Icon = styled.i`
  color: white;
  font-size: 12px;
  visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Checkbox/components/CheckboxStyles.js